import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useHistory, useParams } from 'react-router-dom';

import type { Theme } from '@material-ui/core';
import { AppBar, Tab, Tabs } from '@material-ui/core';

import { ContractRegistrationAccess } from '@klp/contractregistration';
import {
    ContractManagementRoutes,
    ContractManagementTabs,
    ContractManagementRegistrationAccess,
} from '@forvalter/routing/Routes';

import { useKlpStyles } from '@klp/design/Theme/useKlpStyles';

const styles = (theme: Theme) => ({
    appBar: {
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(4),
    },
    tab: {
        fontWeight: 400,
    },
});

type Params = {
    tab?: string;
};

export const ContractManagementAppBar: React.FC = () => {
    const { t } = useTranslation();
    const classes = useKlpStyles({}, styles);
    const history = useHistory();
    const { tab } = useParams<Params>();

    const fallbackTab = ContractManagementTabs.registrering;

    useEffect(() => {
        if (
            !tab ||
            !Object.values(ContractManagementTabs).includes(
                tab as ContractManagementTabs,
            )
        ) {
            history.replace(ContractManagementRoutes.tab(fallbackTab));
        }
    }, [tab, history]);

    const activeTab = Object.values(ContractManagementTabs).includes(
        tab as ContractManagementTabs,
    )
        ? tab
        : fallbackTab;

    if (!ContractRegistrationAccess()) return null;

    return (
        <AppBar position="relative" className={classes.appBar}>
            <Tabs
                indicatorColor="secondary"
                textColor="secondary"
                variant="scrollable"
                orientation="horizontal"
                scrollButtons="on"
                value={activeTab}
            >
                {false && (
                    <Tab
                        label={t('contractManagement.overview')}
                        component={Link}
                        to={ContractManagementRoutes.tab(
                            ContractManagementTabs.avtaler,
                        )}
                        value={ContractManagementTabs.avtaler}
                        className={classes.tab}
                    />
                )}
                {ContractManagementRegistrationAccess() && (
                    <Tab
                        label={t('contractManagement.registrer')}
                        component={Link}
                        to={ContractManagementRoutes.tab(
                            ContractManagementTabs.registrering,
                        )}
                        value={ContractManagementTabs.registrering}
                        className={classes.tab}
                    />
                )}
                <Tab
                    label={t('contractManagement.leko')}
                    component={Link}
                    to={ContractManagementRoutes.tab(
                        ContractManagementTabs.levendekontrakter,
                    )}
                    value={ContractManagementTabs.levendekontrakter}
                    className={classes.tab}
                />
            </Tabs>
        </AppBar>
    );
};
